import React, { useEffect, useState } from "react"
import { getPostitCategoryString } from "../utils/PostitUtils"
import "./EditCardModal.scss"
import { t } from "i18next"

interface IProps {
  card?: ICard
  show: boolean
  onSave: (card: ICard, text: string) => void
  onCancel: () => void
}

const MAX_CHAR_COUNT = 160

const EditCardModal: React.FC<IProps> = ({ show, card, onSave, onCancel }) => {
  const [cardText, setCardText] = useState(card?.text ?? "")
  const [animate, setAnimate] = useState(false)

  useEffect(() => {
    if (show) {
      setAnimate(false)
      // Trigger reflow to restart animation
      setTimeout(() => setAnimate(true), 10)
      setCardText(card?.text ?? "")
    } else {
      setAnimate(false)
    }
  }, [show])

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value.slice(0, MAX_CHAR_COUNT)
    setCardText(value)
  }

  const editCardForm = (card: ICard): React.ReactNode | Promise<React.ReactNode> => {
    return (
      <div className="modal fade show" tabIndex={-1} role="dialog" style={{ display: "block", backgroundColor: "rgba(192,192,192,0.95)" }}>
        <div
          className={`modal-dialog modal-dialog-centered ${animate ? "bouncy-modal" : ""}`}
          role="document"
          style={{
            filter: "drop-shadow(0 8px 32px rgba(0,0,0,0.35))",
            WebkitFilter: "drop-shadow(0 8px 32px rgba(0,0,0,0.35))",
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{t('feedback.title.edit.title')} {getPostitCategoryString(card?.category)}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  onCancel()
                }}
              ></button>
            </div>
            <div className="modal-body">
              <textarea className="form-control" rows={4} value={cardText} onChange={handleChange} maxLength={MAX_CHAR_COUNT}></textarea>
              <div style={{ textAlign: "right", fontSize: "0.9em", color: "#888" }}>
                {cardText.length}/{MAX_CHAR_COUNT}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  onSave(card, cardText ?? "")
                  setCardText(cardText)
                }}
              >
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (!show || !card) return null
  return editCardForm(card)
}

export default EditCardModal
